// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: "https://api.sigma.innsandbox.com/api",
  // apiUrl: "https://testing.sigma-analytics.net/api",
  apiUrl: "https://api.sigma-analytics.net/api",
  firebase: {
    apiKey: "AIzaSyCpCah9GVXC_c53LynPbucEwt2gVxkdGAk",
    authDomain: "sigma-analytics-3028f.firebaseapp.com",
    projectId: "sigma-analytics-3028f",
    storageBucket: "sigma-analytics-3028f.appspot.com",
    messagingSenderId: "583819542610",
    appId: "1:583819542610:web:f471124a321b7302b09f8b",
  },
  // recaptcha: {
  //   siteKey: "6Lfa4vgcAAAAAEGaM_5fr-YBNeJUpeDyskVeymLJ",
  // },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
